const serviceTypes = {
  UnSet: 0,
  IntitialEvaluation: 1,
  AdditionalEvaluation: 2,
  Therapy: 3,
  Assistants: 4,
  AcademicTest: 5,
  AcademicTestWithDocuments: 6,
  Consultancy: 7,
};

export default serviceTypes;
